// import { TimelineLite } from 'gsap'

export default {
    name: 'app-footer',
}